import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Typography } from "@mui/material";

/**
 * Displays an error message and allows a user to retry signing in or sign out.
 */
export default function Auth0Error({ error }) {
    const { logout, loginWithRedirect } = useAuth0();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
            }}
        >
            <Typography
                color="error"
                variant="h5"
                sx={{
                    textAlign: "center",
                }}
            >
                {String(error)}
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "center",
                }}
            >
                <Button
                    variant="contained"
                    onClick={() => loginWithRedirect()}
                >
                    Retry
                </Button>
                <Button variant="contained" onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
                    Sign Out
                </Button>
            </Box>
        </Box>
    );
}
